import { IRefIds } from 'constants/refs';
import { post } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IMultiNavigationData } from 'types/navigation';
import { IPatternConsistencyConfig } from '../modules/Memory/components/MemoryPatternConsistencyConfig';

export type IPatternConsistencyMember = {
  id: number;
  pattern: string; // selected dialect sentence
  count: number;
  navigation_data: IMultiNavigationData;
  items: Array<{ translation_id: number; course_id: number; panel_id?: number }>;
  panel_ids?: number[];
  actions: boolean;
};

export type IPatternConsistencyGroupRow = {
  id: number;
  us_pattern: string;
  size: number;
  variants: string; // "pat1 (3); pat2 (2)"
  members: IPatternConsistencyMember[];
};

export default class MemoryPatternConsistencyModel extends BaseModel<IPatternConsistencyGroupRow> {
  dialectId = 0;
  constructor(options: IModelOptions) {
    super(options);
    this.ref = IRefIds.memory;
    this.gridName = 'MemoryPatternConsistency';
    this.getGridColumns();
  }

  setDialectId(id: number) {
    this.dialectId = id;
  }

  async loadWithConfig(config: IPatternConsistencyConfig) {
    this.cancelGetGrid();
    this.loadingGrid = true;
    this.render();
    const response = await post<IPatternConsistencyGroupRow[]>(`memory/patterns/consistency`, config);
    if (response && response.data) {
      this.gridData = response.data as IPatternConsistencyGroupRow[];
    }
    this.loadingGrid = false;
    this.render();
  }
}
